module.exports = __webpack_public_path__ + "static/img/dd这个视频放最后哦-减速机专用齿轮.mp4.fb881106.jpg";